export default "__VITE_ASSET__CBuiM8kA__"